import LeaveTable from "./LeaveTable";

const AdminLeaveManagement = () => <LeaveTable role="Admin" />;
export default AdminLeaveManagement;